export enum TransactionPlatform {
  IOS = "ios",
  ANDROID = "android",
  OTHER = "other",
}
